/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import { FaInfoCircle, FaPaperclip, FaRegCalendarAlt } from 'react-icons/fa';
import { IoMdCloseCircle, IoIosOptions } from 'react-icons/io';
import ReactQuill from 'react-quill';
import EmailSignatureService from '../../../../service/emailService';
import StatusService from '../../../../../status/service';
import ProtocolService from '../../../../service';
import SchedulingModal from '../SchedulingModal';

import {
  Button,
  DropdownItem,
  DropdownMenu,
  ButtonGroup,
  DropdownToggle,
  Form,
  Input,
  Label,
  UncontrolledDropdown,
  InputGroup,
  InputGroupText,
  UncontrolledTooltip
} from 'reactstrap';
import { useProtocolAttachments } from '../../Attachments/useProtocolAttachments';

import { CreatableFlexSelect } from 'components/Inputs/CreatableSelect';
import PredefinedMessageModal from '../../modal/PredefinedMessageModal';
import PredefinedMessageService from '../../../../../PredefinedMessage/service/index';
import {
  ButtonCCWrapper,
  CheckboxSignatureWrapper,
  CommentsFormWrapper,
  OptionSendSignatureDescription,
  OptionSendSignatureWrapper,
  SpanSignature
} from './styled';
import { LuMail } from 'react-icons/lu';
import { IoText } from 'react-icons/io5';
import { TbMailShare } from 'react-icons/tb';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { apiCase } from '../../../../../../http/index';
import { SearchContactButton } from '../../../../../../../src/components/Buttons/SearchContactButton';
import ModalFilterClients from 'views/Clients/components/ModalFilterClients';

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    [{ font: [] }],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' }
    ],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    ['link', 'image', 'code-block'],
    ['clean']
  ]
};

const EmailToolTip = () => (
  <>
    <FaInfoCircle
      id="email-tooltip-icon"
      style={{
        color: '#5e72e4',
        marginLeft: 6,
        cursor: 'pointer'
      }}
    />
    <UncontrolledTooltip placement="top" target="email-tooltip-icon">
      Você pode alterar o e-mail do destinatário e adicionar mais de um,
      separando-os por vírgula. Exemplo: email1@mail.com, email2@mail.com
    </UncontrolledTooltip>
  </>
);

export default function CommentsForm({
  comment,
  onSubmit,
  onCancel,
  protocol = {},
  replyCommentId = null,
  replyCommentsEmails = null,
  onCloseReplyBox = () => {},
  isForwardingComment = false,
  onForwardAll = () => {},
  onProtocolUpdate = () => {},
  setIsForwardingComment
}) {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const [description, setDescription] = useState('');
  const [isPredefinedMessagesModalOpen, setIsPredefinedMessagesModalOpen] =
    useState(false);
  const [predefinedMessages, setPredefinedMessages] = useState([]);
  const [statusList, setStatusList] = useState([]);

  const [subject, setSubject] = useState('');
  const [recipientEmail, setRecipientEmail] = useState(
    () => protocol?.email || ''
  );
  const [isPrivate, setIsPrivate] = useState(true);
  const [emailsInCopy, setEmailsInCopy] = useState([]);
  const [files, setFiles] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [isCC, setIsCC] = useState(false);
  const [isCCSearchModalOpen, setIsCCSearchModalOpen] = useState(false);
  const [attachmentsToRemove, setAttachmentsToRemove] = useState([]);
  const [sendSignature, setSendSignature] = useState(false);
  const [hasSignature, setHasSignature] = useState(false);
  const defaultMaxFileSize = 5 * 1024 * 1024;
  const [maxFileSize, setMaxFileSize] = useState(defaultMaxFileSize);
  const {
    getFileURL,
    getFileExtensionFromName,
    getIconFromFileExtension,
    getFileNameFormatted
  } = useProtocolAttachments();

  const [sendMode, setSendMode] = useState('private'); // 'private', 'notify', 'close'

  // Busca o tamanho máximo de um arquivo
  const findMaxFileUpload = useCallback(async () => {
    const response = await apiCase.get('/max-upload-file');
    return response.data.maxFileUpload ?? defaultMaxFileSize;
  }, []);

  useEffect(() => {
    PredefinedMessageService.getByChannel('email').then((res) => {
      setPredefinedMessages(res?.data);
    });

    findMaxFileUpload().then((result) => {
      setMaxFileSize(result);
    });
  }, []);

  useEffect(() => {
    if (protocol?.record_type_id) {
      StatusService.getByRecordType(protocol.record_type_id)
        .then((response) => {
          const res = response.data.content;
          setStatusList(res);
        })
        .catch((err) => {
          console.log('Erro ao carregar status/fases:', err);
        });
    }
  }, [protocol?.record_type_id]);

  useEffect(() => {
    if (protocol?.comments && protocol?.comments?.length > 0) {
      const text = protocol?.comments[0]?.subject ?? '';
      setSubject(text);
    }
  }, [protocol]);

  useEffect(() => {
    if (replyCommentsEmails) {
      setRecipientEmail(replyCommentsEmails);
    }
  }, [replyCommentsEmails]);

  const handleDescriptionChange = (event) => {
    setDescription(event);
  };

  const handleAddNewFile = async (event) => {
    if (!event?.target?.files || !event?.target?.files.length) return;

    const uploadedFiles = [...event?.target?.files];

    const fileAlreadyUploaded = [...uploadedFiles].some((uploadedFile) =>
      files.some((file) => file.name === uploadedFile.name)
    );

    if (fileAlreadyUploaded) {
      event.target.value = '';
      return;
    }

    const filesWithMaxSize = [];

    const newUploadFiles = uploadedFiles.filter((file) => {
      if (file.size >= maxFileSize) {
        filesWithMaxSize.push(file.name);
        return false;
      }
      return true;
    });

    if (filesWithMaxSize.length) {
      toast.info(
        `Os arquivos ${filesWithMaxSize.join(
          ','
        )} excede o tamanho máximo permitido `
      );
    }
    setFiles([...files, ...newUploadFiles]);

    event.target.value = '';
  };

  const handleAddNewFileLink = async (data) => {
    if (!data?.url || data?.url?.length === 0) return;

    const response = await fetch(data.url);
    const blob = await response.blob();
    let fileName = data.url.split('/').pop();

    const file = new File([blob], fileName, { type: blob.type });

    const fileAlreadyUploaded = files.some(
      (currentFile) => file.name === currentFile.name
    );

    if (fileAlreadyUploaded) {
      return toast.error('O Arquivo ja está em anexo', {
        autoClose: 3000,
        closeOnClick: true
      });
    }

    const filesWithMaxSize = [];

    if (file.size >= maxFileSize) {
      filesWithMaxSize.push(file.name);
    }

    if (filesWithMaxSize.length) {
      toast.info(
        `O arquivo ${filesWithMaxSize.join(
          ','
        )} excede o tamanho máximo permitido`
      );
      return;
    }
    setFiles((prevFiles) => [...prevFiles, file]);
  };

  const handleRemoveFile = useCallback((fileName) => {
    setFiles((prevState) => prevState.filter((file) => file.name !== fileName));
  }, []);

  const handleDeleteAttachment = useCallback((attachmentId) => {
    setAttachments((prevState) =>
      prevState.filter((attachment) => attachment.id !== attachmentId)
    );

    setAttachmentsToRemove((prevState) => {
      if (!prevState.includes(attachmentId)) {
        return [...prevState, attachmentId];
      }
      return prevState;
    });
  }, []);

  const showCC = (e) => {
    e.preventDefault();
    setIsCC(!isCC);
  };

  const handleSubjectChange = (e) => {
    setSubject(e.target.value);
  };

  const handleEmailChange = (e) => {
    setRecipientEmail(e.target.value);
  };

  function handleSubmit(callback) {
    return async (event) => {
      event.preventDefault();
      const cleanedDescription = description.replace(/<[^>]*>?/gm, '').trim();
      if (!cleanedDescription) {
        return toast.error('O comentário não pode estar vazio', {
          autoClose: 3000,
          closeOnClick: true
        });
      }

      // Validação de email se não for privado
      if (!isPrivate && !recipientEmail) {
        return toast.error('Informe o email do destinatário', {
          autoClose: 3000,
          closeOnClick: true
        });
      }

      const formData = new FormData();

      // Destinatários (incluindo emails em cópia)
      const allRecipients = [recipientEmail, ...emailsInCopy];
      allRecipients.map((rcp) => formData.append('recipients[]', rcp));

      if (isForwardingComment || protocol?.selectedComments?.length > 0) {
        // Dados básicos
        formData.append('userId', localStorage.getItem('login'));
        formData.append('subject', subject);
        formData.append('description', description);
        formData.append('sendSignatureEmail', sendSignature);

        // Lógica de encaminhamento
        if (protocol?.selectedComments?.length === 1) {
          formData.append('commentForwarding', protocol.selectedComments[0]);
          formData.append('forwardAllComments', false);
        } else {
          formData.append('commentForwarding', protocol.selectedComments[0]);
          formData.append('forwardAllComments', true);
        }

        // Anexos
        for (const file of files) {
          formData.append('attachments[]', file, file.name);
        }

        await callback(formData);
        setDescription('');
        setFiles([]);
        setEmailsInCopy([]);
        onCloseReplyBox();
        return;
      }

      // Para comentários normais e respostas
      formData.append('description', description);
      formData.append('is_private', isPrivate);
      formData.append('sendSignatureEmail', sendSignature);

      if (recipientEmail !== '') {
        formData.append('emailsTo', recipientEmail);
      }

      if (emailsInCopy && emailsInCopy.length > 0) {
        formData.append('emailsInCopy', emailsInCopy.join(','));
      }

      if (replyCommentId) {
        formData.append('replyToComment', replyCommentId);
      }

      for (const file of files) {
        formData.append('attachments[]', file, file.name);
      }

      for (const attachmentToRemove of attachmentsToRemove) {
        formData.append('attachmentsToRemove[]', attachmentToRemove);
      }

      callback(formData).then(() => {
        setDescription('');
        setIsPrivate(true);
        setFiles([]);
        comment && onCancel();
        onCloseReplyBox();

        // Recarregar o protocolo para atualizar o status na interface
        onProtocolUpdate();
      });
    };
  }

  async function mustSendSignature(userLogin) {
    await EmailSignatureService.mustSendSignature(userLogin);
  }

  useEffect(() => {
    EmailSignatureService.getSignature(localStorage.getItem('login'))
      .then((response) => {
        if (response) {
          setHasSignature(true);
          setSendSignature(response.must_send);
        }
      })
      .then(() => {});
  }, []);

  useEffect(() => {
    if (!comment) return;
    setDescription(comment.description);
    setIsPrivate(comment.is_private);
    setAttachments(comment.attachments);
  }, [comment]);

  useEffect(() => {
    if (isCC) setEmailsInCopy(protocol?.emailsInCopy || []);
    else setEmailsInCopy([]);
  }, [isCC, protocol?.emailsInCopy]);

  const handleCloseProtocol = async () => {
    try {
      if (!statusList || statusList.length === 0) {
        toast.error(
          'É necessário definir pelo menos uma fase/status para o protocolo.',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
        return;
      }

      const lastStatus = statusList[statusList.length - 1];
      if (!lastStatus) {
        toast.error('Não foi possível encontrar a última fase', {
          autoClose: 3000,
          closeOnClick: true
        });
        return;
      }

      // Se já está na última fase, apenas informar sucesso
      if (protocol?.protocol_statuses?.[0]?.status?.id === lastStatus.id) {
        toast.success('O protocolo já está na última fase (encerrado).', {
          autoClose: 3000,
          closeOnClick: true
        });
        setDescription('');
        setFiles([]);
        setEmailsInCopy([]);
        onCloseReplyBox();
        onProtocolUpdate();
        return;
      }

      // Atualizar o status do protocolo para a última fase
      await ProtocolService.protocolUpdateData(
        protocol.id,
        { status_id: lastStatus.id },
        'change_status'
      );

      toast.success(
        `Protocolo encerrado com sucesso. Status alterado para: ${lastStatus.name}`,
        {
          autoClose: 3000,
          closeOnClick: true
        }
      );

      setDescription('');
      setFiles([]);
      setEmailsInCopy([]);
      onCloseReplyBox();
      onProtocolUpdate();
    } catch (error) {
      console.error('Erro ao encerrar protocolo:', error);
      toast.error('Erro ao encerrar o protocolo', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  // Atualizar modo ao selecionar as opções do dropdown
  const handleSetPrivate = () => setSendMode('private');
  const handleSetNotify = () => setSendMode('notify');
  const handleSetClose = () => setSendMode('close');

  useEffect(() => {
    if (isForwardingComment && sendMode !== 'notify') {
      handleSetNotify();
    }
  }, [isForwardingComment, sendMode, handleSetNotify]);

  // Submit customizado conforme o modo
  const handleCustomSubmit = handleSubmit(async (formData) => {
    if (sendMode === 'close' || sendMode === 'notify') {
      formData.set('is_private', false);
    } else {
      formData.set('is_private', true);
    }
    if (scheduledDate && scheduledHour) {
      const [day, month, year] = scheduledDate.split('/');
      const scheduleDatetime = new Date(
        `${year}-${month}-${day}T${scheduledHour}:00`
      );
      formData.set('scheduledDate', scheduleDatetime.toISOString());
    }
    try {
      if (typeof onSubmit === 'function') {
        await onSubmit(formData);
      }
      if (sendMode === 'close') {
        await handleCloseProtocol();
      }
    } catch (e) {
      toast.error('Ocorreu um erro durante o envio.');
      console.error(e);
      throw e;
    }
  });

  const [isSchedulingModalOpen, setIsSchedulingModalOpen] = useState(false);
  const [scheduledDate, setScheduledDate] = useState('');
  const [scheduledHour, setScheduledHour] = useState('');

  return (
    <>
      <PredefinedMessageModal
        setEmailFiles={handleAddNewFileLink}
        predefinedMessages={predefinedMessages}
        open={isPredefinedMessagesModalOpen}
        setIsOpen={setIsPredefinedMessagesModalOpen}
        setPredefinedMessage={setDescription}
        messageFieldsToRender={['messageHtml']}
        transformResult={(predefinedMessage) =>
          ` ${description} ${predefinedMessage.messageHtml} `
        }
      />
      <ModalFilterClients
        className="modal-lg"
        show={isCCSearchModalOpen}
        onModalToggle={setIsCCSearchModalOpen}
        setSelectedClient={(contact) => {
          if (contact?.clientEmail) {
            const newEmail = contact?.clientEmail;
            setEmailsInCopy((prev) => {
              let current = Array.isArray(prev) ? [...prev] : [];
              if (!current.includes(newEmail)) {
                current.push(newEmail);
              }
              return current;
            });
          }
          setIsCCSearchModalOpen(false);
        }}
      />

      <Form
        className="needs-validation rounded p-2"
        style={{
          background: '#fff',
          border: '1px solid #cbd5e1',
          boxShadow: 'rgba(203, 213, 225,.5) 0px 0rem 1rem 1px'
        }}
        onSubmit={handleCustomSubmit}
        autoComplete="off"
      >
        <div
          className="rounded overflow-hidden"
          style={{
            marginBottom: '4px'
          }}
        >
          {!comment && (
            <>
              <InputGroup style={{ display: 'flex', alignItems: 'center' }}>
                <InputGroupText
                  className="form-control-label"
                  style={{
                    width: '100%',
                    borderRight: 'none',
                    borderTop: 'none',
                    borderBottom: 'none',
                    borderRadius: '0px',
                    borderLeft: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '.8rem',
                    color: '#525f7f'
                  }}
                >
                  <LuMail />
                  <Input
                    type="text"
                    name="to"
                    value={recipientEmail}
                    onChange={handleEmailChange}
                    placeholder="Digite o email do destinatário"
                    required={!isPrivate}
                    style={{
                      border: 'none',
                      background: 'transparent',
                      color: '#525f7f',
                      padding: 0,
                      margin: 0,
                      width: '100%'
                    }}
                  />
                  <EmailToolTip />
                </InputGroupText>
                <ButtonGroup>
                  <ButtonCCWrapper color={isCC}>
                    <Button className="form-control-label" onClick={showCC}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '.8rem'
                        }}
                      >
                        <TbMailShare />
                        CC
                      </div>
                    </Button>
                  </ButtonCCWrapper>
                </ButtonGroup>
              </InputGroup>
              {isCC && (
                <InputGroup
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <InputGroupText
                    className="form-control-label"
                    style={{
                      width: '8rem',
                      borderRadius: '0px',
                      borderWidth: '1px 0 0px 0',
                      color: '#525f7f',
                      flexShrink: 0,
                      height: '48px',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '.8rem',
                        color: '#525f7f'
                      }}
                    >
                      <TbMailShare />
                      CC
                    </div>
                  </InputGroupText>
                  <div
                    style={{ position: 'relative', flex: 1, maxWidth: '800px' }}
                  >
                    <CreatableFlexSelect
                      style={{ width: '100%', height: '100%' }}
                      validation={(value) => !emailRegex.test(value)}
                      itemStyle={{
                        color: '#FFF',
                        borderWidth: '1px',
                        borderColor: '#ced4da'
                      }}
                      controlStyle={{
                        height: '48px',
                        width: '100%',
                        borderRadius: '0px',
                        borderTopWidth: '1px',
                        borderLeft: 'none',
                        borderBottom: 'none',
                        borderRight: 'none',
                        borderColor: '#ced4da',
                        paddingRight: '70px'
                      }}
                      value={emailsInCopy || []}
                      setValue={setEmailsInCopy}
                      defaultValue={protocol?.emailsInCopy || []}
                      isCommentWithSearch={true}
                    />
                    <div
                      style={{
                        position: 'absolute',
                        right: 8,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 10,
                        pointerEvents: 'auto'
                      }}
                    >
                      <SearchContactButton
                        onClick={() => setIsCCSearchModalOpen(true)}
                      />
                    </div>
                  </div>
                </InputGroup>
              )}

              <InputGroup
                style={{
                  alignItems: 'center',
                  opacity: sendMode !== 'notify' ? 0.5 : 1,
                  pointerEvents: sendMode !== 'notify' ? 'none' : 'auto'
                }}
              >
                <InputGroupText
                  className="form-control-label"
                  style={{
                    border: 'none',
                    boxShadow: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    color: '#525f7f'
                  }}
                >
                  <FaRegCalendarAlt style={{ marginRight: '0.5rem' }} />
                  Agendar comentário para:
                </InputGroupText>
                <div
                  style={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    background: '#fff',
                    padding: '0.375rem 0.75rem',
                    fontSize: '1rem',
                    lineHeight: 1.5,
                    color: '#525f7f'
                  }}
                >
                  <span>
                    {scheduledDate && scheduledHour
                      ? `${scheduledDate} às ${scheduledHour}`
                      : 'Não agendado'}
                  </span>

                  <Button
                    size="sm"
                    color={sendMode === 'notify' ? 'primary' : 'secondary'}
                    onClick={() => {
                      if (sendMode === 'notify') {
                        setIsSchedulingModalOpen(true);
                      }
                    }}
                  >
                    Definir data e hora
                  </Button>
                </div>
              </InputGroup>

              <InputGroup style={{ display: 'flex', alignItems: 'center' }}>
                <InputGroupText
                  className="form-control-label"
                  style={{
                    width: '8rem',
                    minHeight: '50px',
                    borderRight: 'none',
                    borderRadius: '0px',
                    borderLeft: 'none',
                    boxShadow: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '.8rem',
                    color: '#525f7f'
                  }}
                >
                  <IoText />
                  Assunto
                </InputGroupText>

                <Input
                  style={{
                    boxShadow: 'none',
                    minHeight: '50px',
                    borderRight: 'none',
                    borderLeft: 'none',
                    flex: 1
                  }}
                  type="text"
                  name="subject"
                  placeholder=""
                  value={subject}
                  onChange={handleSubjectChange}
                  className="rounded-0 p-2"
                />
              </InputGroup>
            </>
          )}

          <CommentsFormWrapper>
            <ReactQuill
              modules={modules}
              name="description"
              theme="snow"
              placeholder="Escreva um comentário"
              defaultValue={description}
              onChange={handleDescriptionChange}
              value={description}
              style={{
                border: 'none',
                boxShadow: 'none',
                color: '#525f7f'
              }}
            />
          </CommentsFormWrapper>

          {files.length || attachments.length ? (
            <div className="bg-white p-2 d-flex flex-column align-items-start">
              {attachments.map((attachment) => (
                <div
                  key={attachment.id}
                  title={attachment.name}
                  className="attachment-name-container p-2 pr-5 br-2 position-relative"
                >
                  <img
                    src={getIconFromFileExtension(
                      getFileExtensionFromName(attachment.name)
                    )}
                    width="24px"
                    height="24px"
                    alt={attachment.name}
                    className="d-inline-block mr-2"
                  />
                  <a
                    href={getFileURL(attachment.path)}
                    target="_blank"
                    rel="noopener noreferrer"
                    download={true}
                    style={{
                      fontSize: '14px',
                      color: '#525f7f'
                    }}
                  >
                    {getFileNameFormatted(attachment.name)}
                  </a>
                  <IoMdCloseCircle
                    type="button"
                    onClick={() => handleDeleteAttachment(attachment.id)}
                    className="delete-icon"
                    style={{ color: '#525f7f' }}
                  />
                </div>
              ))}
              {files.map((file, index) => (
                <div
                  key={index}
                  title={file.name}
                  className="attachment-name-container p-2 pr-5 br-2 position-relative"
                >
                  <img
                    src={getIconFromFileExtension(
                      getFileExtensionFromName(file.name)
                    )}
                    width="24px"
                    height="24px"
                    alt={file.name}
                    className="d-inline-block mr-2"
                  />
                  <span
                    style={{
                      fontSize: '14px',
                      color: '#525f7f'
                    }}
                  >
                    {getFileNameFormatted(file.name)}
                  </span>
                  <IoMdCloseCircle
                    type="button"
                    onClick={() => handleRemoveFile(file.name)}
                    className="delete-icon"
                    style={{ color: '#525f7f' }}
                  />
                </div>
              ))}
            </div>
          ) : null}
        </div>

        <div className="pt-3 pb-2 d-flex justify-content-between align-items-center">
          <div>
            <div>
              <Label
                htmlFor="file"
                style={{
                  cursor: 'pointer',
                  margin: '0 0 0 1rem',
                  padding: '10px',
                  display: 'inline-flex',
                  backgroundColor: systemConfiguration.primary_color,
                  borderRadius: '50%',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px'
                }}
              >
                <FaPaperclip size={16} color="#fff" />
              </Label>
              <Input
                id="file"
                type="file"
                multiple
                onChange={handleAddNewFile}
                hidden
                size={maxFileSize}
                accept=".png, .jpeg, .jpg, .pdf, .doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, .csv, .rar"
              />
            </div>
          </div>
          {comment ? (
            <div>
              <Button
                type="button"
                color="danger"
                title="Cancelar atualização"
                onClick={onCancel}
                Cancelar
              >
                Cancelar
              </Button>

              <Button
                color="primary"
                title="Atualizar comentário"
                disabled={description === ''}
              >
                Atualizar comentário
              </Button>
            </div>
          ) : (
            <div>
              <UncontrolledDropdown group>
                <Button
                  color={sendMode === 'close' ? 'danger' : 'success'}
                  title={
                    sendMode === 'close'
                      ? 'Encerrar e notificar'
                      : sendMode === 'notify'
                      ? 'Comentar e notificar'
                      : 'Comentar privado'
                  }
                  disabled={!description.replace(/<[^>]*>?/gm, '').trim()}
                  type="submit"
                >
                  {sendMode === 'close'
                    ? 'Encerrar e notificar'
                    : sendMode === 'notify'
                    ? 'Comentar e notificar'
                    : 'Comentar privado'}
                </Button>
                <DropdownToggle data-toggle="dropdown" caret color="success" />
                <DropdownMenu
                  right
                  style={{
                    width: '352px'
                  }}
                >
                  <DropdownItem
                    onClick={() => {
                      handleSetPrivate();
                      setIsForwardingComment(false);
                    }}
                    style={{
                      whiteSpace: 'break-spaces'
                    }}
                  >
                    <span>Comentário privado</span>
                    <p
                      className="m-0"
                      style={{
                        fontSize: '12px'
                      }}
                    >
                      Um comentário privado só pode ser visualizado pela
                      plataforma do FlexUC
                    </p>
                  </DropdownItem>
                  <DropdownItem
                    onClick={handleSetNotify}
                    style={{
                      whiteSpace: 'break-spaces'
                    }}
                  >
                    <span>Comentário notificar</span>
                    <p
                      className="m-0"
                      style={{
                        fontSize: '12px'
                      }}
                    >
                      Será enviado um email para o cliente com o comentário
                    </p>
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem
                    onClick={onForwardAll}
                    style={{
                      whiteSpace: 'break-spaces'
                    }}
                  >
                    <span>Encaminhar histórico</span>
                    <p
                      className="m-0"
                      style={{
                        fontSize: '12px'
                      }}
                    >
                      Encaminhar todos os comentários do protocolo
                    </p>
                  </DropdownItem>
                  <DropdownItem
                    onClick={handleSetClose}
                    style={{ whiteSpace: 'break-spaces', color: 'red' }}
                  >
                    <span>Encerrar</span>
                    <p className="m-0" style={{ fontSize: '12px' }}>
                      Enviar email e alterar o status para encerrado
                    </p>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>

              <UncontrolledDropdown group>
                <DropdownToggle data-toggle="dropdown" caret color="success">
                  <IoIosOptions size={20} />
                </DropdownToggle>
                <DropdownMenu
                  right
                  style={{
                    width: '352px'
                  }}
                >
                  <DropdownItem
                    onClick={() =>
                      setIsPredefinedMessagesModalOpen(
                        !isPredefinedMessagesModalOpen
                      )
                    }
                  >
                    <span>Mensagens pré-definidas</span>
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      mustSendSignature(localStorage.getItem('login'));
                      setSendSignature(!sendSignature);
                    }}
                    disabled={!hasSignature}
                  >
                    <SchedulingModal
                      isOpen={isSchedulingModalOpen}
                      toggle={() => setIsSchedulingModalOpen(false)}
                      date={scheduledDate}
                      hour={scheduledHour}
                      setDate={setScheduledDate}
                      setHour={setScheduledHour}
                    />
                    <OptionSendSignatureWrapper>
                      <OptionSendSignatureDescription>
                        <span>Enviar assinatura</span>
                        <p
                          className="m-0"
                          style={{
                            fontSize: '12px'
                          }}
                        >
                          Enviar assinatura para o cliente
                          <br />
                          {!hasSignature && (
                            <SpanSignature>
                              (assinatura não cadastrada)
                            </SpanSignature>
                          )}
                        </p>
                      </OptionSendSignatureDescription>
                      <CheckboxSignatureWrapper>
                        <Input
                          type="checkbox"
                          name="signature"
                          id="signature"
                          className="ml-2"
                          checked={sendSignature}
                        />
                      </CheckboxSignatureWrapper>
                    </OptionSendSignatureWrapper>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          )}
        </div>
      </Form>
      <div className="d-block small px-2 mt-4 text-left">
        Tamanho máximo dos anexos é de {maxFileSize / (1024 * 1024)}mb
      </div>
    </>
  );
}
